import { useEffect, useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import fetchProducts from "pages/Catalog/helpers/fetchProducts";
import ListState from "pages/Catalog/models/state.interface";
import ProductItem from "pages/Catalog/models/item.interface";

export default (categoryId?: string): any => {
    const navigate = useNavigate();
    const location = useLocation();
    const language = useSelector((state: any) => state.page.languageId);

    const initialItems: ProductItem[] = (location.state as any)?.products;
    const [items, setItems] = useState<ProductItem[]>(initialItems);

    const [viewState, setViewState] = useState<string>(initialItems?.length > 0 ? "LOADED" : "LOADING");

    useEffect(() => {
        let isComponentMounted = true;

        const getProducts = async () => {
            let result: ProductItem[] = [];
            const response = await fetchProducts(location.pathname, language);

            if (response && response.length > 0) {
                result = response;
            }

            if (isComponentMounted) {
                return result;
            }
        };

        if (categoryId && !initialItems) {
            setViewState("LOADING");
            const setFetching = getProducts();
            const setLoading = new Promise((resolve) => { setTimeout(resolve, 500); });
    
            Promise.all([setFetching, setLoading]).then((values) => {
                const result = values[0];
    
                if (result && result.length > 0) {
                    setItems(result);

                    navigate(location.pathname, {
                        replace: true,
                        state: {
                            ...(location.state as any),
                            products: result
                        }
                    });
    
                    setViewState("LOADED");
                } else {
                    setViewState("EMPTY");
                }
            }).catch(() => {
                setViewState("ERROR");
            });
        }

        return () => {
            isComponentMounted = false;
        };
    }, [categoryId]);

    return [items, viewState];
};